import gql from 'graphql-tag';

export const UpdateClientMutation = gql`
  mutation updateClient($id: ID!, $data: UpdateClientInput!) {
    updateClient(id: $id, data: $data) {
      id
    }
  }
`;
